import { createFileRoute, useLocation, useNavigate } from '@tanstack/react-router';
import { useTheme, useMediaQuery } from '@mui/material';
import { useCallback, useEffect } from 'react';
import {
  ContainerTypeLegacy,
  GrainBinDashboard,
  navigateTo,
  useAuth,
  useGetViewer,
  ContainerSelectionArgs,
} from '@amber-ui/core';

function GrainBinDashboardRoute() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const theme = useTheme();
  // down('md') = < 960px, matches AuthLayout's mobile_width definition (width === 'sm' || 'xs').
  // Previously used down('sm') || only('xs') which was < 600px — inconsistent with AuthLayout.
  const matchesMobile = useMediaQuery(theme.breakpoints.down('md'));
  const mobile_width = matchesMobile;

  // Read entity IDs from URL search params (source of truth)
  const { bin, acct } = Route.useSearch();
  const { account_id: session_account_id } = useAuth();
  const { viewer } = useGetViewer();

  const grain_bin_id = bin || null;
  const effectiveAccountId = acct || session_account_id || (viewer ? viewer.account_id : '');

  // Redirect to operations view when no grain bin is selected (matches old behavior)
  useEffect(() => {
    if (viewer && !grain_bin_id) {
      void navigate({ to: '/grain/operations', replace: true });
    }
  }, [viewer, grain_bin_id, navigate]);

  const goCreateBarge = useCallback(() => {
    navigateTo('/barge/create');
  }, []);
  const goCreatePile = useCallback(() => {
    navigateTo('/pile/create');
  }, []);
  const goCreateGrainBin = useCallback(() => {
    navigateTo('/grain_bin/create');
  }, []);
  const onSelectContainer = useCallback((selected: ContainerSelectionArgs) => {
    if (selected.container_type === ContainerTypeLegacy.bin) {
      navigateTo('/grain_bin/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.barge) {
      navigateTo('/barge/dashboard', selected);
    } else if (selected.container_type === ContainerTypeLegacy.pile) {
      navigateTo('/pile/dashboard', selected);
    }
  }, []);

  if (!viewer) return <div>Loading viewer...</div>;
  if (!grain_bin_id) return null; // redirect is in flight

  return (
    <GrainBinDashboard
      viewer={viewer}
      grain_bin_id={grain_bin_id}
      pathname={pathname}
      onSelectContainer={onSelectContainer}
      goCreateBarge={goCreateBarge}
      goCreatePile={goCreatePile}
      goCreateGrainBin={goCreateGrainBin}
      mobile_width={mobile_width}
      url_base="/grain_bin"
      current_account_id={effectiveAccountId}
    />
  );
}

export const Route = createFileRoute('/_auth/_grain-bin/grain_bin/dashboard')({
  component: GrainBinDashboardRoute,
});
